import React from 'react';
import moment from 'moment';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {Box, DatePicker} from '@acuity-brands/fusion';
import {FusionPropTypes} from '../prop-types';

/**
 * @note Only for use inside the Form component. If you need to use
 * the Fusion DatePicker component, use it directly.
 */
export const FusionDatePickerAdapter = ({
  data,
  disabled,
  errors,
  field,
  handleChange,
  name,
}) => (
  <Box sx={{width: '100%'}}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        disabled={disabled}
        label={field.widget.attrs.hideLabel ? '' : field.label}
        name={name}
        onChange={(momentDate) => {
          handleChange(momentDate.toISOString());
        }}
        required={field.required && !field.widget.attrs.hideLabel}
        slotProps={{
          textField: {
            error: errors && errors.length > 0,
            errorTextPosition: 'left',
            helperText: errors && errors.length > 0 ? errors[0] : null,
            placeholder: field.widget.attrs.placeholder,
          },
        }}
        sx={{width: '100%'}}
        tooltip={field.help_text}
        value={data ? moment(data) : null}
      />
    </LocalizationProvider>
  </Box>
);

FusionDatePickerAdapter.propTypes = FusionPropTypes;
